module.exports = __webpack_public_path__ + "media/images/static/benefit/fig_merit1-1_crew_point_paypay-b7a7af9c8baf128572f18a244b9ae64d.png";